import { postWithAuth, getWithAuth, putWithAuth } from '../../Basic/HttpService';

export const getAllServiceAgentDash = async () => {
    let res = await getWithAuth(`ServiceAgentDashboard`);
    return res;
};
export const GetServiceAgentTopDashboardData = async () => {
    let res = await getWithAuth(`ServiceAgentDashboard/GetServiceAgentTopDashboardData`);
    return res;
};
